import { writable, get } from "svelte/store";
import { TopicService } from "$/services/TopicService";
import { BackgroundService } from "$/services/BackgroundService";
import {} from "$/stores/HighlightStore";
import { isBlogPostOrArticle } from "$/utils/CustomLocateV4/marker/utils";
let TopicServiceImpl = (chrome === null || chrome === void 0 ? void 0 : chrome.storage) ? BackgroundService : TopicService;
const store = () => {
    const { subscribe, set, update } = writable(new Map());
    return {
        subscribe,
        fetchTriggers: async (pageUrl, document) => {
            if (!isBlogPostOrArticle(document))
                return [];
            const triggers = await TopicServiceImpl.getKnowledgeTriggers(pageUrl);
            update((triggerMap) => {
                const triggerArray = triggers.map((trigger) => ({
                    id: trigger.id,
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                    group: "trigger",
                    url: pageUrl,
                    content: trigger.content,
                    highlight: trigger.highlight,
                    originalId: trigger.id,
                }));
                triggerMap.set(pageUrl, triggerArray);
                return triggerMap;
            });
            return get(KnowledgeTriggerStore).get(pageUrl) || [];
        },
        setTriggerPosition: (triggerId, pageUrl, top, left, width, height) => {
            update((triggerMap) => {
                const triggers = triggerMap.get(pageUrl) || [];
                const updatedTriggers = triggers.map(trigger => {
                    if (trigger.id === triggerId) {
                        return Object.assign(Object.assign({}, trigger), { top,
                            left,
                            width,
                            height });
                    }
                    return trigger;
                });
                triggerMap.set(pageUrl, updatedTriggers);
                return triggerMap;
            });
        },
        setTriggerGroup: (triggerId, pageUrl, group) => {
            update((triggerMap) => {
                const triggers = triggerMap.get(pageUrl) || [];
                const updatedTriggers = triggers.map(trigger => {
                    if (trigger.id === triggerId) {
                        return Object.assign(Object.assign({}, trigger), { group });
                    }
                    return trigger;
                });
                triggerMap.set(pageUrl, updatedTriggers);
                return triggerMap;
            });
        },
        getTriggers: (pageUrl) => {
            return get(KnowledgeTriggerStore).get(pageUrl) || [];
        },
        clearTriggers: (pageUrl) => {
            update((triggerMap) => {
                triggerMap.delete(pageUrl);
                return triggerMap;
            });
        },
        clearAllTriggers: () => {
            set(new Map());
        },
    };
};
export const KnowledgeTriggerStore = store();
